var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3412",
    "data-name": "Group 3412",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.844,
    height: 25.829,
    viewBox: "0 0 25.844 25.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_879",
    "data-name": "Rectangle 879",
    width: 25.844,
    height: 25.829,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3411",
    "data-name": "Group 3411",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12439",
    "data-name": "Path 12439",
    d: "M14.124,0c.474.061.952.068,1.426.133a13.117,13.117,0,0,1,7.714,3.55,8.2,8.2,0,0,1,1.269,10.405c-.121.2-.256.395-.389.589a1.032,1.032,0,1,1-1.728-1.127,8.189,8.189,0,0,0,1.054-2.057,5.913,5.913,0,0,0-1.245-5.863,10.185,10.185,0,0,0-5.762-3.238,13.3,13.3,0,0,0-3.731-.3A13.4,13.4,0,0,0,5.586,4.482a8.3,8.3,0,0,0-3.061,3.7,5.955,5.955,0,0,0,.683,5.868A7.985,7.985,0,0,0,4.14,15.14a.217.217,0,0,0,.324.034,3.04,3.04,0,0,1,4.657,2.075c.086.509.092.516.625.615a14.446,14.446,0,0,0,4.189.149,14.158,14.158,0,0,0,5.113-1.521,1.02,1.02,0,0,1,1.445.418,1.037,1.037,0,0,1-.507,1.424,15.541,15.541,0,0,1-5.131,1.655,16.227,16.227,0,0,1-6.179-.238.359.359,0,0,0-.4.11,2.551,2.551,0,0,1-.967.668c-.162.065-.181.149-.146.31a3.885,3.885,0,0,1-.351,2.928A4.7,4.7,0,0,1,4.715,25.56a3.965,3.965,0,0,1-.536.219,1.05,1.05,0,0,1-1.318-.666,1.028,1.028,0,0,1,.632-1.289,4.778,4.778,0,0,0,1-.534,1.92,1.92,0,0,0,.39-2.615,1.226,1.226,0,0,0-.4-.373A2.98,2.98,0,0,1,3.1,17.247a.43.43,0,0,0-.172-.413A9.221,9.221,0,0,1,.884,14.2,8.016,8.016,0,0,1,.034,11.4,1.168,1.168,0,0,0,0,11.249V9.736c.02-.141.038-.281.061-.421A9.384,9.384,0,0,1,2.7,4.235,13.078,13.078,0,0,1,7,1.312,15.246,15.246,0,0,1,11.463.132C11.93.083,12.4.044,12.863,0ZM6.094,18.7a.971.971,0,1,0,.025-1.942A.971.971,0,1,0,6.094,18.7",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGroup);
export default __webpack_public_path__ + "static/media/icon_group.900b7b4411be48e028937aa1ff8c643c.svg";
export { ForwardRef as ReactComponent };